export default "__VITE_ASSET__5111e94f__"